export default __webpack_public_path__ + "static/media/avatar_5.625ca9d7.svg";